"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetOverride = exports.OVERRIDE_FEATURES = void 0;
const app_feature_interface_1 = require("./app-feature.interface");
exports.OVERRIDE_FEATURES = new Map();
const resetOverride = (category) => {
    if (category) {
        exports.OVERRIDE_FEATURES.set(category, []);
    }
    else {
        exports.OVERRIDE_FEATURES.set(app_feature_interface_1.APP_FEATURE_CATEGORY.ADMIN, []);
        exports.OVERRIDE_FEATURES.set(app_feature_interface_1.APP_FEATURE_CATEGORY.GENERAL, []);
        exports.OVERRIDE_FEATURES.set(app_feature_interface_1.APP_FEATURE_CATEGORY.CUSTOMER, []);
    }
};
exports.resetOverride = resetOverride;
//# sourceMappingURL=app-feature.map.js.map